export enum ORIENTATION {
    landscape = 'landscape',
    portrait = 'portrait'
}